import { applyMiddleware, compose, legacy_createStore } from "redux";
import { thunk } from "redux-thunk";
import rootPageReducer from "./reducerRootPage";
import { useDispatch, useSelector, useStore } from 'react-redux';

// @ts-ignore
const composeEnhancers = (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

export const storePage = legacy_createStore(rootPageReducer, {}, composeEnhancers(applyMiddleware(thunk)));

export type StorePage = typeof storePage;
export type StorePageState = ReturnType<StorePage['getState']>;
export type StorePageDispatch = StorePage['dispatch'];
export const useDispatchPage = useDispatch.withTypes<StorePageDispatch>();
export const useSelectorPage = useSelector.withTypes<StorePageState>();
export const useStorePage = useStore.withTypes<StorePage>();

